__turbopack_context__.v({
  "button": "pagination-module-scss-module__PPu2tG__button",
  "container": "pagination-module-scss-module__PPu2tG__container",
  "icon": "pagination-module-scss-module__PPu2tG__icon",
  "item": "pagination-module-scss-module__PPu2tG__item",
  "list": "pagination-module-scss-module__PPu2tG__list",
  "selected": "pagination-module-scss-module__PPu2tG__selected",
});
